<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp; Salary Slip</h5>
  </div>
<div id="mainContent" class="container">
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Branch<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <mat-form-field appearance="legacy" style="width: 100%">
              <mat-select
                multiple
                [(ngModel)]="selectedBranch"
                #designateBranch="ngModel"
              >
                <mat-option
                  (click)="selectAllBranch(designateBranch, branchList)"
                  [value]="0"
                  >Select All
                </mat-option>
                <mat-option
                  #item
                  *ngFor="let branch of branchList"
                  [value]="branch"
                  (click)="onBranchSelect()"
                >
                  {{ branch.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Employee Status<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedEmployeeStatus"
              (change)="onEmployeeStatusSelect()"
            >
              <option value="1">Active</option>
              <option value="0">Closed</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-4">
            <label for="approversName" class="form-label"
              >Employee Name <span class="text-danger">*</span></label
            >
          </div>
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedEmployeeName"
              (change)="onEmployeeNameSelect()"
            >
              <option value="">Select Employee</option>
              <option *ngFor="let emp of employeeList" [ngValue]="emp">
                {{ emp.firstName }} {{ emp.middleName }} {{ emp.lastName }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Financial Year<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedFinancialYear"
              (change)="onFinancialYearSelected()"
            >
              <option value="">Select Year</option>
              <option *ngFor="let finance of financialList" [ngValue]="finance">
                {{ finance.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >From Closing Date<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedFromClosing"
            >
              <option value="">Select From Date</option>
              <option
                *ngFor="let closing of closingDateList"
                [ngValue]="closing"
              >
                {{ closing.closingDate }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >To Closing Date<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedToClosing"
            >
              <option value="">Select To Date</option>
              <option
                *ngFor="let closing of closingDateList"
                [ngValue]="closing"
              >
                {{ closing.closingDate }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-sm-2">
        <button
          type="button"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="onViewReport()"
        >
          View Report
        </button>
      </div>
      <div class="col-sm-2">
        <button
          type="button"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="onExportToExcelReport()"
          *ngIf="showExportToExcelButton"
        >
          Export To Excel
        </button>
      </div>

      <div class="col-sm-2">
        <button
          (click)="convertSalarySlipReportIntoPDF()"
          *ngIf="showExportToExcelButton"
           class="btn btn-sm btn-block btn-outline-theme"
       >
          <i class="fa fa-file-pdf-o mr-2"></i>Export as PDF
        </button>
      </div>
    </div>
  </div>
  </div>

  <div class="container" id="mainContent"> 
    <div class="pt-2" *ngIf="salarySlipReportList.length>0" id="contentToConvert">
      <div class="row justify-content-center text-center" style="padding-top: 10px;">
        <span class="bg-theme-title"
          >P G BHAGWAT LLP, Chartered Accountants
        </span>
      </div>
      <div class="row justify-content-center text-center ">
        <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
      </div>
      <div class="row mt-2">
        <div class="col-sm-5"></div>
        <div class="col-sm-7">
          <span class="bg-theme-title">Salary Slip</span>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4"></div>
        <div class="col-sm-8">
          <span class="bg-theme-title">From: {{selectedFromClosing.closingDate}} To: {{selectedToClosing.closingDate}}</span>
        </div>
      </div>
      <div class="row mt-2" style="width:3500px;padding-left: 50px;padding-right: 30px;">
      <table>
          <tr><td style="background-color:#87cefa;font-weight: bold;">Month - Year</td></tr>
          <tr><td style="font-weight: bold;">Name</td></tr>
          <tr><td style="font-weight: bold;">Designation</td></tr> 
          <tr><td style="font-weight: bold;">Date Of Joining</td></tr>
          <tr><td style="font-weight: bold;">Payable Days</td></tr>
          <tr><td style="font-weight: bold;">Leave Days</td></tr> 
          <tr><td style="font-weight: bold;">Bank Account Number</td></tr> 
          <tr><td style="background-color:#87cefa;font-weight: bold;">Salary</td></tr> 
          <tr><td style="font-weight: bold;">Basic Salary</td></tr> 
          <tr><td style="font-weight: bold;">Conveyance Allowance</td></tr> 
          <tr><td style="font-weight: bold;">Mobile Allowance</td></tr> 
          <tr><td style="font-weight: bold;">HRA Allowance</td></tr> 
          <tr><td style="font-weight: bold;">Other Allowances</td></tr> 
          <!-- <tr><td style="font-weight: bold;">Education Allowance</td></tr> 
          <tr><td style="font-weight: bold;">Child Hostel Allowance</td></tr>  -->
          <tr><td style="font-weight: bold;">Bonus</td></tr> 
          <tr><td style="font-weight: bold;">Overtime</td></tr>
          <tr><td style="font-weight: bold;">Reimbursement of Conveyance</td></tr> 
          <tr><td style="font-weight: bold;">Travelling Allowance</td></tr>
          <tr><td style="font-weight: bold;">Advance</td></tr> 
          <tr><td style="font-weight: bold;">Loan</td></tr> 
          <tr><td style="font-weight: bold;">Leave Encashment</td></tr> 
          <tr><td style="font-weight: bold;">EPF (ER)</td></tr> 
          <tr><td style="font-weight: bold;">ESIC (ER)</td></tr> 
          <tr><td style="font-weight: bold;">GROSS SALARY</td></tr> 
          <tr><td style="background-color:#87cefa;font-weight: bold;">DEDUCTIONS</td></tr> 
          <tr><td style="font-weight: bold;">Professional Tax</td></tr> 
          <tr><td style="font-weight: bold;">TDS</td></tr> 
          <tr><td style="font-weight: bold;">EPF (ER)</td></tr>
          <tr><td style="font-weight: bold;">EPF (EE)</td></tr>
          <tr><td style="font-weight: bold;">ESIC (ER)</td></tr> 
          <tr><td style="font-weight: bold;">ESIC (EE)</td></tr> 
          <tr><td style="font-weight: bold;">Security Deposit</td></tr> 
          <tr><td style="font-weight: bold;">Penalty</td></tr>
          <tr><td style="font-weight: bold;">Leave</td></tr>
          <tr><td style="font-weight: bold;">Advance Travel Recovery</td></tr> 
          <tr><td style="font-weight: bold;">Recovery/Expenses</td></tr> 
          <tr><td style="font-weight: bold;">Loan EMI</td></tr>
          <tr><td style="font-weight: bold;">Total Deduction</td></tr>
          <tr><td style="font-weight: bold;">Net Salary</td></tr>
        <tbody>
        </tbody>
      </table>  
          <div  *ngFor="let detail of salarySlipReportList">
              <div class="border border-dark border-left-0" style="background-color:#87cefa;color:white"><span class="alignmentClass">{{detail.monthName}} - {{detail.yearName}}</span></div>
              <div class="border border-dark border-top-0 border-left-0" ><span class="alignmentClass">{{detail.firstName}} {{detail.middleName}} {{detail.lastName}}</span></div>
              <div class="border border-dark border-top-0 border-left-0" ><span class="alignmentClass">{{detail.designation}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.joiningDate | date:'dd/MMMM/yyyy'}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.payableDays}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.leaveDays}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.bankAccountNumber}}</span></div>
              <div class="border border-dark border-top-0 border-left-0" style="background-color:#87cefa;color:white;height: 27px;"><span class="alignmentClass"></span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.basicSalary}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.conveyanceAllowance}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.mobileAllowance}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.hraAllowance}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.otherAllowances}}</span></div>
              <!-- <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.educationalAllowance}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.childHostelAllowance}}</span></div> -->
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.bonus}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.overtime}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.reimbursementOfConveyance}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.travellingAllowance}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.advance}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.loan}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.leaveEncashment}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.providentFundEr}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.esicEmployerContribution}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.grossSalary}}</span></div>
              <div class="border border-dark border-top-0 border-left-0" style="background-color:#87cefa;color:white; height: 27px;"><span class="alignmentClass"></span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.professionalTax}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.tds}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.providentFundEr}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.providentFundEe}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.esicEmployerContribution}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.esicEmployeeContribution}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.securityDeposit}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.penalty}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.leaves}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.travellingAdvance}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.recovery}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.emi}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.totalDedcuctions}}</span></div>
              <div class="border border-dark border-top-0 border-left-0"><span class="alignmentClass">{{detail.netSalary}}</span></div>
        </div>
      </div>
    </div>
  </div>
</div>
